import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";

const GroupRadioCell = ({ props }) => {
  const { tableProps } = props;

  const groupId = tableProps?.groupSelectionId;

  const [checked, setChecked] = useState(
    tableProps?.tableSelectedItems?.includes(groupId) || false,
  );

  useEffect(() => {
    setChecked(tableProps?.tableSelectedItems?.includes(groupId) || false);
  }, [tableProps?.tableSelectedItems, groupId]);

  const handleChange = (e) => {
    const isChecked = e.currentTarget.checked;

    setChecked(isChecked);

    if (isChecked) {
      tableProps.setTableSelectedItems([groupId]);
    } else {
      tableProps.setTableSelectedItems([]);
    }
  };

  return (
    <Form.Check
      type="checkbox"
      name="score-range-group"
      checked={checked}
      onChange={handleChange}
      id={`indi-score-range-group-${groupId}`}
    />
  );
};

export default GroupRadioCell;
